<template>
  <div class="profile">
    <img v-if="avatar"
         :src="avatar"
         class="profile__avatar"
         alt="avatar"
    >
    <div v-else-if="firstLast"
         class="profile__text"
    >
      {{ firstLast }}
    </div>
    <v-icon v-else
            name="userSimple"
            height="24"
            width="24"
            stroke="var(--color-white)"
    />
  </div>
</template>

<script>
export default {
  name: 'ProfileIcon',
  props: {
    firstLast: { type: String, default: () => '' },
    avatar: { type: String, default: () => '' },
  },
};
</script>
<style lang="scss" scoped>
.profile {
  height: 40px;
  width: 40px;
  // background: linear-gradient(180deg, #0052cc 0%, var(--color-accent) 100%);
  background: $primary-color;
  border-radius: 50%;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  @include flex-center;

  color: var(--color-white);
  cursor: pointer;
  overflow: hidden;

  &__avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
